import {createSvgIcon} from '../create-svg-icon';

export const KeyboardCapslockIcon = createSvgIcon(
  <path d="M12 8.41 16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z" />
, 'KeyboardCapslockOutlined');
